import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = ({to, ...props}) => {
    return <Link className="nav-item" to={to}>{props.children}</Link>
}

export default Navbar